module.exports = __webpack_public_path__ + "img/icon补直角.1718f412.png";